import { Modal } from 'antd';

export interface ConfirmUnpublishArgs {
  label: string;
  slotPosition: number | null;
  onConfirm: () => void;
}

// Shared by the Browser and Point carousel-banner admin pages — identical copy/behavior
// in both, only the banner's own display label (campaignCode vs name) differs by caller.
export function confirmUnpublish({ label, slotPosition, onConfirm }: ConfirmUnpublishArgs): void {
  const slotWarning =
    slotPosition != null ? ` This banner is in slot ${slotPosition}. Unpublishing removes it from the carousel.` : '';

  Modal.confirm({
    title: 'Unpublish this banner?',
    content: `Unpublish ${label || 'this banner'}? It will stop showing to users.${slotWarning}`,
    okText: 'Unpublish',
    okButtonProps: { danger: true },
    onOk: onConfirm,
  });
}
